class SizeSelect extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('focusout', this.handleFocusOut);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('focusout', this.handleFocusOut);
    document.removeEventListener('click', this.handleOutsideClick);
  }

  get trigger() {
    return this.querySelector('[data-size-select-trigger]');
  }

  get menu() {
    return this.querySelector('[data-size-select-menu]');
  }

  get options() {
    return Array.from(this.querySelectorAll('[data-size-option]'));
  }

  get open() {
    return this.trigger?.getAttribute('aria-expanded') === 'true';
  }

  toggle(open = !this.open) {
    const { trigger, menu } = this;
    if (!trigger || !menu) return;
    trigger.setAttribute('aria-expanded', String(open));
    menu.hidden = !open;
    document.removeEventListener('click', this.handleOutsideClick);
    if (open) {
      setTimeout(() => document.addEventListener('click', this.handleOutsideClick));
      (this.options.find((option) => option.getAttribute('aria-selected') === 'true') ?? this.options[0])?.focus();
    }
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) this.toggle(false);
  }

  handleFocusOut(event) {
    if (this.open && !this.contains(event.relatedTarget)) this.toggle(false);
  }

  handleClick(event) {
    if (event.target.closest('[data-size-select-trigger]')) return this.toggle();
    const option = event.target.closest('[data-size-option]');
    if (!option) return;
    this.choose(option);
  }

  choose(option) {
    const input = document.getElementById(option.dataset.sizeOption);
    this.toggle(false);
    this.trigger?.focus();
    if (!input) return;
    if (input.checked) {
      input.dispatchEvent(new Event('size-reselected', { bubbles: true }));
      return;
    }
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.open) {
      event.preventDefault();
      this.toggle(false);
      this.trigger?.focus();
      return;
    }
    if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    if (!this.open) return this.toggle(true);
    const { options } = this;
    const index = options.indexOf(document.activeElement);
    const step = event.key === 'ArrowDown' ? 1 : -1;
    options[(index + step + options.length) % options.length]?.focus();
  }
}

customElements.define('size-select', SizeSelect);
